import { Container, Text, Ticker } from "pixi.js"
import Clock from "./Clock"
import { SCALE_FACTOR, SCREEN_HEIGHT, SCREEN_WIDTH } from "./config"

export type OverlayTextType = "centered" | "scrolling" | "top"

export default class OverlayText extends Text {
  private _container: Container
  private _type: OverlayTextType
  speed: number
  onRemove?: () => void

  constructor(params: {
    text: string,
    duration?: number,
    container: Container,
    type: OverlayTextType,
    color?: number,
    speed?: number
    onRemove?: () => void
  }) {
    super({
      text: params.text,
      style: {
        fontSize: 20 * SCALE_FACTOR,
        fill: params.color || 0xffffff,
        align: "center",
        fontFamily: "Jaro, ui-sans-serif, system-ui, sans-serif",
        stroke: { color: 0x000000, width: 5 * SCALE_FACTOR, join: "bevel" },
      }
    })

    this._type = params.type
    this._container = params.container
    this._container.addChild(this)
    this.speed = params.speed || 10

    if (params.duration) {
      Clock.setTimeout(() => {
        this.remove()
      }, params.duration)
    }

    this.onRemove = params.onRemove
    this.anchor.set(0.5)
    if (this._type === "centered") {
      this.x = SCREEN_WIDTH / 2
      this.y = SCREEN_HEIGHT / 2 - this.height / 2
    } else if (this._type === "scrolling") {
      this.x = SCREEN_WIDTH + this.width / 2
      this.y = SCREEN_HEIGHT / 2 - this.height / 2
    } else if (this._type === "top") {
      this.x = SCREEN_WIDTH / 2
      this.y = SCREEN_HEIGHT / 8
    }

    this.zIndex = +Infinity
  }

  remove() {
    this._container.removeChild(this)

    if (this.onRemove) {
      this.onRemove()
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  tickUpdate(_ticker: Ticker) {
    if (this._type === "scrolling") {
      this.x -= this.speed
      if (this.x + this.width < 0) {
        this.remove()
      }
    }
  }
}
